import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import classNames from "classnames";
import { toast } from "react-toastify";

import { deleteCart, modifyCart, updateCart } from "../redux/actions/cartActions";
import { checkCartProceed } from "../services/HomePageService";
import { isAuthenticated } from "../auth";
import { trimString } from "../helpers/helperFunctions";
import { REACT_APP_IMAGE_BASE_PATH } from "../helpers/config";
import emptyCartIcon from "../assets/images/empty-cart.png";
import { toggleCartAction } from "../redux/actions/uiActions";
import { DirhamSymbol } from "./DirhamSymbol";
const CartDrawer = ({ handleCartToggle, cartCount, data }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const show = useSelector((state) => state.sideDrawerReducer.cartDraw);

  const {
    subTotal = 0,
    totalSaving = 0,
    cartItems = [],
    totalAvailability = 0,
    minorder = 0,
  } = data;

  const [loadingItemId, setLoadingItemId] = useState(null);

    const toggle = (e) => {
      e.preventDefault();
      dispatch(toggleCartAction());
    };

  const handleQuantityChange = async (id, product_id, quantity) => {
    setLoadingItemId(id);
    const result = await modifyCart({ id, product_id, quantity });
    if (result) dispatch(updateCart(result));
    else toast.error("Failed to update item quantity.");
    setLoadingItemId(null);
  };

  const handleDelete = async (id, product_id, quantity) => {
    setLoadingItemId(id);
    const result = await deleteCart({ id, product_id, quantity });
    if (result) dispatch(updateCart(result));
    else toast.error("Failed to remove item from cart.");
    setLoadingItemId(null);
  };

  const handleCheckout = async (e) => {
    e.preventDefault();

    if (totalAvailability > 0) {
      return toast.error("One or more items are currently out of stock.");
    }

    handleCartToggle(e);

    // const cartProceed = await checkCartProceed();
    // const { status, message } = cartProceed;

    // if (status === 200) {
    //   isAuthenticated()
    //     ? navigate("/checkout")
    //     : navigate("/login", { state: { callBackUrl: "/checkout" } });
    // } else {
    //   toast.error(message || "Unable to proceed to checkout.");
    // }
         if(!isAuthenticated())
                 navigate("/login", { state: { callBackUrl: "/checkout" } });
                else 
                 navigate("/checkout")
  };

  return (
    <>
    <div className={classNames("bs-canvas bs-canvas-left position-fixed bg-cart h-100", { "mr-0": show })}>
      <div className="bs-canvas-header side-cart-header p-3">
        <div className="main-cart-title">
          My Cart <span>({cartCount} {cartCount === 1 ? "Item" : "Items"})</span>
        </div>
        {/* <button className="bs-canvas-close close" onClick={handleCartToggle}>
          <i className="uil uil-multiply" />
        </button> */}
      </div>

      <div className="bs-canvas-body">
        {cartCount === 0 ? (
          <div className="empty-cart">
            <img src={emptyCartIcon} alt="empty" />
            <h3>Your cart is currently empty</h3>
            <div className="start-btn">
              <Link to="/">Continue Shopping</Link>
            </div>
          </div>
        ) : (
          <div className="side-cart-items">
            {cartItems.map((item) => {
              const {
                id, image, sku, name, price, display_price,
                product_id, quantity, slug, availability,
                options = [], maximumOrderQuantity,
              } = item;

              return (
                <div className={`cart-item ${availability === 0 ? "not_available" : ""}`} key={id}>
                  <div className="cart-product-img">
                    <Link to={`/product/${sku}/${slug}`}>
                      <img src={`${REACT_APP_IMAGE_BASE_PATH}/${image}`} alt={name} />
                    </Link>
                  </div>
                  <div className="cart-text">
                    {availability === 0 && <p className="product_not_stock">This item is out of stock</p>}
                    <h4>
                      <Link to={`/product/${sku}/${slug}`}>{trimString(name)}</Link>
                    </h4>

                    {options.length > 0 && (
                      <ul className="kggrm-now checkout-atr-list">
                        {options.map(({ attr_id, attr_value_id, attr_value_name }) => (
                          <li key={`option_${attr_id}_${attr_value_id}`}>{attr_value_name}</li>
                        ))}
                      </ul>
                    )}

                    <div className="qty-group">
                      <div className="quantity buttons_added">
                        <button
                          className="minus minus-btn"
                          onClick={() => handleQuantityChange(id, product_id, quantity - 1)}
                          disabled={quantity <= 1 || loadingItemId === id}
                        >
                          -
                        </button>

                        {loadingItemId === id ? (
                          <span className="spinner-border" />
                        ) : (
                          <input type="number" value={quantity} readOnly className="input-text qty text" />
                        )}

                        <button
                          className="plus plus-btn"
                          onClick={() => handleQuantityChange(id, product_id, quantity + 1)}
                          disabled={quantity >= maximumOrderQuantity || loadingItemId === id}
                        >
                          +
                        </button>
                      </div>

                      <div className="cart-item-price">
                        {display_price !== price ? (
                          <>
                            <span className="before-offer"> <DirhamSymbol/>{price}</span> <DirhamSymbol/> {display_price}
                          </>
                        ) : (
                          <><DirhamSymbol/> {price}</>
                        )}
                      </div>
                    </div>

                    <button
                      onClick={() => handleDelete(id, product_id, quantity)}
                      className="cart-close-btn"
                    >
                      {loadingItemId === id ? (
                        <span className="spinner-border" />
                      ) : (
                        <i className="uil uil-multiply" />
                      )}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {cartCount > 0 && (
        <div className="bs-canvas-footer">
          <div className="cart-total-dil saving-total">
            <h4>Total Saving</h4>
            <span><DirhamSymbol/> {totalSaving}</span>
          </div>
          <div className="main-total-cart">
            <h2>Total</h2>
            <span><DirhamSymbol/> {subTotal}</span>
          </div>
          <div className="checkout-cart">
            <Link to="/checkout" 
            onClick={handleCheckout}
             className="cart-checkout-btn hover-btn">
              Proceed to Checkout
            </Link>
          </div>
        </div>
      )}
    </div>
     <div onClick={toggle}  className={classNames("zeynep-overlay", { "d-block": show })}></div>
     </>
  );
};

export default CartDrawer;
